import {Divider, Space, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const ValidationFF = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Validation</Paragraph>
        <Space size={80} align="center" style={{background: 'inherit', width: 'fit-content', marginTop: '-2%', textAlign: 'center'}}>
          <Content style={{float: 'left', background: 'inherit', marginTop: '6%'}}>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh'}}>Jorge Chedraui</Paragraph>
            <Text className='BaseText5'>Engineer in Biotechnology with a concentration in Bioprocesses. He completed the Green Belt Lean Six Sigma certification, was the winner of the Molson Coors Award for R&D 2019 and has his own startup related to beer.</Text>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh', textAlign: 'center'}}>Knowledge</Paragraph>
            <Text className='BaseText5'>
              <ul>
                <li>Develop a financial plan</li>
                <li>How to make a product profitable?</li>
                <li>Cost analysis, CAPEX, company value, profitability</li>
              </ul>
            </Text>
          </Content>
          <Content style={{width: 'fit-content', display: 'block', marginTop: '3%', background: 'transparent'}}>
            <Image width="90%" src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-69.jpg'/>
          </Content>
        </Space>
        <Space size={80} align="center" style={{background: 'inherit', width: 'fit-content', marginTop: '3%', textAlign: 'center'}}>
          <Content style={{width: 'fit-content', display: 'block', marginTop: '3%', background: 'transparent'}}>
            <Image width="80%" src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-70.jpg'/>
          </Content>
          <Content style={{float: 'left', background: 'inherit', marginTop: '6%'}}>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh'}}>Álvaro de Obeso</Paragraph>
            <Text className='BaseText5'>Professor at the Tecnológico de Monterrey, He participated in Bioyes 2015 (Youth entrepreneurship scheme) in Schevening UK, experience in obtaining funding for biotechnology research</Text>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh', textAlign: 'center'}}>Knowledge</Paragraph>
            <Text className='BaseText5'>
              <ul>
                <li>Strategies to obtain financing for a biotech project</li>
                <li>What is a technological enterprise?</li>
                <li>How to collaborate with other institutes?</li>
                <li>Types of financing</li>
              </ul>
            </Text>
          </Content>
        </Space>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default ValidationFF;
